import React from 'react';
import { Link } from 'react-router-dom'
const giveaway = process.env.REACT_APP_LINK_GIVEAWAY;
const coupons = process.env.REACT_APP_LINK_COUPONS;
const hotdeals = process.env.REACT_APP_LINK_HOT_DEALS;
const monthlyads = process.env.REACT_APP_LINK_MONTHLY_ADS;
const recipes = process.env.REACT_APP_LINK_RECIPES;
const community = process.env.REACT_APP_LINK_COMMUNITY;

const facebook = 'https://www.facebook.com/MyMilitarySavings/';
const x = 'https://x.com/MyMilitarySvgs';
const pinterest = "https://www.pinterest.com/mymilitarysvngs/";
const instagram = "https://www.instagram.com/mymilitarysvgs/";
const youtube = "https://www.youtube.com/MyMilitarySavings/";

const Home = "https://www.mymilitarysavings.com/";
const About = "https://www.mymilitarysavings.com/about-us";
const Advertise = "https://www.mymilitarysavings.com/advertisers";
const Exchange = "https://www.mymilitarysavings.com/my-exchange";
const commissary = "https://www.mymilitarysavings.com/my-commissary";
const Travel = "https://www.mymilitarysavings.com/travel";
const Shopping_list = "https://www.mymilitarysavings.com/profile/sign-in";
const Commissary_exchange = "https://www.mymilitarysavings.com/commissary-exchange-base-locations";
const Exchange_coupons_pages = "https://www.mymilitarysavings.com/exchange-coupons-pages";
const Commissary_coupons = "https://www.mymilitarysavings.com/commissary-coupons-pages";
const Military_discounts = "https://www.mymilitarysavings.com/military-discounts-pages";
const Military_vacation = "https://www.mymilitarysavings.com/military-vacation-deals-pages"
const My_home_base_pages = "https://www.mymilitarysavings.com/my-home-base-pages";
const Articles = "https://www.mymilitarysavings.com/articles";
const Contact_us = "https://www.mymilitarysavings.com/about-us/contact-us";
// const Privacy = "https://www.mymilitarysavings.com/about-us/privacy";
const Help = "https://www.mymilitarysavings.com/about-us/help";
const Bbig = "https://bbigcommunications.com/";


const Footer = () => {
    return (
        <footer className='mt-auto'>
            <div className="tp-footer-area tp-footer-style-2 tp-footer-style-primary tp-footer-style-6">
                <div className="tp-footer-top pt-95 pb-40">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-4 col-lg-3 col-md-4 col-sm-6">
                                <div className="tp-footer-widget footer-col-1 mb-20">
                                    <div className="tp-footer-widget-content">
                                        <div className="tp-footer-logo">
                                            <a href="/">
                                                <img src="/assets/img/logo/logo.png" alt="logo" />
                                            </a>
                                        </div>
                                        <div className="tp-footer-social">
                                            <a href={facebook} ><i className="fa-brands fa-facebook-f"></i></a>
                                            <a href={x} ><i className="fa-brands fa-x-twitter"></i></a>
                                            <a href={pinterest} ><i className="fa-brands fa-pinterest-p"></i></a>
                                            <a href={instagram} ><i className="fa-brands fa-instagram"></i></a>
                                            <a href={youtube} ><i className="fa-brands fa-youtube"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                                <div className="tp-footer-widget footer-col-3 mb-20">
                                    {/* <h4 class="tp-footer-widget-title">About</h4> */}
                                    <div className="tp-footer-widget-content">
                                        <ul>
                                            <li><a href="/" className="active">Insider</a></li>
                                            <li><a href={Home}>Home</a></li>
                                            <li><Link to={'/aboutus'}> About Us</Link></li>
                                            <li><a href={Advertise}> Advertise</a></li>
                                            <li><a href={Exchange}>My Exchange</a></li>
                                            <li><a href={coupons} >Coupons</a></li>
                                            <li><a href={commissary}> My Commissary</a></li>
                                            <li><a href={giveaway} > Contests</a></li>
                                            <li><a href={community}> Community</a></li>
                                            <li><a href={recipes}> Recipes</a></li>
                                            <li><a href={hotdeals} >Hot Deals</a></li>
                                            <li><a href={monthlyads}> Monthly Ads</a></li>
                                            <li><a href={Travel}> Travel &amp; Lifestyle</a></li>
                                            <li><a href="/"> Brands</a></li>
                                            <li><a href={Shopping_list}>  Shopping List</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                <div className="tp-footer-widget footer-col-3 mb-20">
                                    <div className="tp-footer-widget-content">
                                        <ul>
                                            <li><a href={Commissary_exchange}> Commissary and Exchange Base Locations</a></li>
                                            <li><a href={Commissary_coupons}> Commissary Coupons | Pages</a></li>
                                            <li><a href={Exchange_coupons_pages}>  Exchange Coupons | Pages</a></li>
                                            <li><a href={Military_discounts}> Military Discounts | Pages</a></li>
                                            <li><a href={Military_vacation}> Military Vacation Deals | Pages</a></li>
                                            <li><a href={My_home_base_pages}> My Home Base | Pages</a></li>
                                            <li><a href={Articles}>Articles</a></li>
                                            <li><a href={Contact_us}>Contact Us</a></li>
                                            <li><Link to='/Terms'>Terms and Conditions</Link></li>
                                            <li><Link to='/privacy'>Privacy</Link></li>
                                            <li><a href={Help}>  Help</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                <div className="tp-footer-widget footer-col-4 mb-20">
                                    <h4 className="tp-footer-widget-title">Contact Us</h4>
                                    <div className="tp-footer-widget-content">
                                        <div className="tp-footer-contact">
                                            <div className="tp-footer-contact-item d-flex align-items-start">
                                                <div className="tp-footer-contact-icon">
                                                    <span>
                                                        <i className="fa-solid fa-at" />
                                                    </span>
                                                </div>
                                                <div className="tp-footer-contact-content">
                                                    <p><a href="mailto:info@mymilitarysavings.com">info@mymilitarysavings.com</a></p>
                                                </div>
                                            </div>
                                            <div className="tp-footer-contact-item d-flex align-items-start">
                                                <div className="tp-footer-contact-icon">
                                                    <span>
                                                        <i className="fa-solid fa-location-dot" />
                                                    </span>
                                                </div>
                                                <div className="tp-footer-contact-content">
                                                    <p><Link>17817 Davenport Rd. Ste 325 <br /> Dallas, Texas 75252</Link></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tp-footer-bottom pb-25">
                    <div className="container">
                        <div className="tp-footer-bottom-wrapper">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <div className="tp-footer-copyright text-center">
                                        <p>© 2025 MyMilitarySavings.com Inc., <br />Produced by <a href={Bbig} className="f_white">bBIG Communications</a></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
